import {DateField, name, Panes, RadioGroup, Select, TextField} from '@management-ui/core';
import React, {useCallback, useContext, useEffect, useMemo, useRef, useState} from 'react';
import {ServiceContext} from '../../../../components/Services';
import {useSelector} from 'react-redux';

const Fields = ({task = {}, prefix = ''}) => {
  const user = useSelector(state => state['auth'].user);
  const userCanManage = useMemo(() => user.permissions.can_manage_tasks, [user]);
  const services = useContext(ServiceContext);
  const [users, setUsers] = useState([]);
  const optionsLoaded = useRef(false);

  useEffect(() => {
    if (!optionsLoaded.current) {
      optionsLoaded.current = true;
      services.user.getUsers({}, 1, 500).then((list) => {
        setUsers(list.data.filter(user => user.permissions.can_complete_tasks).map((user) => ({
          title: name(user),
          value: user.id
        })));
      }).catch(() => null);
    }
  }, [services]);

  const handleReset = useCallback((subject) => {
    if (subject.assignee) {
      subject.assignee_id = `${subject.assignee.id}`;
    }
    return subject;
  }, []);

  return (
    <Panes
      entity={task}
      prefix={prefix}
      onReset={handleReset}
      panes={[
        {
          title: 'Main Details',
          fields: [
            <TextField
              name="title"
              prefix={prefix}
              label="Title"
              rules={{required: 'Please enter a title'}}
            />,
            <Select
              name="assignee_id"
              prefix={prefix}
              label="Assignee"
              options={users}
              rules={{required: 'Please select an assignee for this task'}}
              fieldProps={{disabled: !userCanManage}}
            />,
            <TextField
              name="description"
              prefix={prefix}
              label="Description"
              fieldProps={{multiline: true, rows: 6}}
            />,
            <DateField
              name="deadline"
              prefix={prefix}
              label="Deadline"
              rules={{required: 'Please select a deadline for this task'}}
            />,
            <RadioGroup
              name="priority"
              prefix={prefix}
              label="Priority"
              options={[
                {title: 'Low', value: 'Low'},
                {title: 'Medium', value: 'Medium'},
                {title: 'High', value: 'High'},
              ]}
              rules={{required: 'Please select a priority level for this task'}}
            />
          ]
        },
        {
          title: 'Recurring Tasks',
          fields: [
            <RadioGroup
              name="schedule"
              prefix={prefix}
              label="Recurrence Schedule"
              options={[
                {title: 'None', value: ''},
                {title: 'Every Week', value: 'weekly'},
                {title: 'Every 2 Weeks', value: 'fortnightly'},
                {title: 'Every Month', value: 'monthly'},
                {title: 'Every 6 Months', value: 'semi-annually'},
                {title: 'Every 12 Months', value: 'annually'},
              ]}
            />
          ]
        },
      ]}
      title=""/>
  );
};

export default Fields;
